<template>
    <Header class="register-header" />
    <Loader v-if="isLoading"></Loader>
    <div v-else-if="hasUnknownError" class="register container is-fluid">
        <h1>Fehler</h1>
        <p class="registration-confirm-error">Es ist ein Fehler aufgetreten.</p>
    </div>
    <div v-else-if="hasInvalidConfirmTokenError" class="register container is-fluid">
        <h1>Fehler</h1>
        <p class="registration-confirm-error">Der Bestätigungslink ist ungültig oder abgelaufen.</p>
    </div>
    <div v-else class="register container is-fluid">
        <h1>Vielen Dank für Ihre Registrierung!</h1>
        <p>Sobald Ihr Kundenkonto aktiviert wurde, senden wir Ihnen eine Bestätigungs-E-Mail mit Ihren Zugangsdaten.
            Anschließend können Sie sich einloggen.
        </p>
    </div>
</template>

<script>
import Header from '@/views/components/ui/Register/Header'
import Loader from '@/views/components/ui/Loader';

const ERROR_UNKNOWN = 'UNKNOWN_ERROR';
const ERROR_INVALID_CONFIRM_TOKEN = 'INVALID_CONFIRM_TOKEN';

export default {
    name: 'Register',
    components: {
        Header,
        Loader,
    },
    props: ['mandantId', 'confirmToken'],
    data() {
        return {
            isLoading: true,
            error: '',
        }
    },
    computed: {
        hasUnknownError() {
            return this.error === ERROR_UNKNOWN;
        },
        hasInvalidConfirmTokenError() {
            return this.error === ERROR_INVALID_CONFIRM_TOKEN;
        },
    },
    methods: {
        async confirmRegistration() {
            try {
                const requestPayload = {
                    mandantId: this.mandantId,
                    confirmToken: this.confirmToken,
                }
                await this.$store.dispatch('confirmRegistration', requestPayload)
                this.error = ''
                this.isLoading = false
            } catch (error) {
                if (error === ERROR_INVALID_CONFIRM_TOKEN) {
                    this.error = ERROR_INVALID_CONFIRM_TOKEN
                    this.isLoading = false
                    return
                }

                console.error('Error when confirming registration: ', error)
                this.error = ERROR_UNKNOWN
                this.isLoading = false
            }
        },
    },
    beforeMount() {
        this.confirmRegistration(this.registrationConfigurationId)
    },
}
</script>

<style lang="scss">
.registration-confirm-error {
    color: $warning-color;
}
</style>
